import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    reportParams: {},
    activeName: 0,
    reportTypes: [
      { label: "Simple", value: "simple" },
      { label: "Lateness", value: "lateness" },
      { label: "Workforce", value: "workforce" },
      { label: "Absentee", value: "absentee" },
      { label: "Log", value: "logs" },
      { label: "Break Time", value: "breaktime" },
      { label: "Punctuality", value: "punctuality" },
      { label: "Attendance Summary", value: "summary" },
      { label: "Overtime Summary", value: "overtime_summary" },
      { label: "Early In", value: "earlyIn" },
      { label: "Off Day", value: "offday" },
      { label: "Overtime", value: "overtime" },
    ],
    employeeOnlyGroups: ["punctuality", "summary", "overtime_summary", "logs"],
  },
  actions,
  mutations,
};
